import { render, staticRenderFns } from "./ChangeMetadataRequestPage.vue?vue&type=template&id=89232ccc&lang=pug"
import script from "./ChangeMetadataRequestPage.vue?vue&type=script&lang=js"
export * from "./ChangeMetadataRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89232ccc')) {
      api.createRecord('89232ccc', component.options)
    } else {
      api.reload('89232ccc', component.options)
    }
    module.hot.accept("./ChangeMetadataRequestPage.vue?vue&type=template&id=89232ccc&lang=pug", function () {
      api.rerender('89232ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_pendings/ChangeMetadataRequestPage.vue"
export default component.exports